import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useWithdrawal } from 'src/components';
import { Product } from 'src/constants';
import {
  useCheckMAMViewOnlyChildType,
  useEnv,
  useUpgradeAccountStatus,
} from 'src/hooks';
import { useAccountStatementTrack } from 'src/pages/TransactionReport/AccountStatement/hooks';

export const useBalanceTooltipImpl = () => {
  const dispatch = useDispatch();
  const { currentEnv: env } = useEnv();
  const { trackClickWithdraw, trackClickHowToTopup } =
    useAccountStatementTrack();

  const { isSubmitting: isSubmittingWithdrawal } = useWithdrawal();
  const { isViewOnlyChildActive } = useCheckMAMViewOnlyChildType();
  const { isApproved } = useUpgradeAccountStatus();
  const [showModalWarning, setModalWarning] = useState(false);
  const [product, setProduct] = useState<Product>(Product.Acceptance);

  const openWithdrawal = () => {
    trackClickWithdraw(env);
    if (isApproved) {
      dispatch({
        type: 'SET_WITHDRAWAL',
        payload: {
          isModalOpen: true,
        },
      });

      return;
    }
    setProduct(Product.Disbursement);
    setModalWarning(true);
  };

  const onClickTopUp = () => {
    trackClickHowToTopup();
    if (isApproved) {
      dispatch({
        type: 'SET_TOPUP_SHOW',
      });
      return;
    }
    setProduct(Product.Acceptance);
    setModalWarning(true);
  };

  const onCloseModalWarning = () => {
    setModalWarning(false);
  };

  const state = {
    isSubmittingWithdrawal,
    isViewOnlyChildActive,
    showModalWarning,
    product,
  };

  return { state, onClickTopUp, openWithdrawal, onCloseModalWarning };
};
